import { Texts, Button, Title } from "../Object";
import { Space } from "../Layout";

const Contact = () => {
  return(
    <>
      <div className="p-box__wrap--contact">
        <Space size={['104px', '56px']}></Space>
        <div className="l-row">
          <div className="c-grid--center">
            <Title slug="contact" enClass="c-text--white" jpClass="c-text--white c-text--center"></Title>
          </div>
          <Space size={['48px 0', '40px 0']}>
            <Texts class="c-text--center c-text--white" slug={`contact/body`}></Texts>
          </Space>
          <Button link="/contact/" slug="contact" type="accent"></Button>
        </div>
        <Space size={['80px', '80px']}></Space>
      </div>
    </>
  )
}
export default Contact;